class MedicalHistoryInfectiousDisease {
    public VaricellaDisease?: boolean;
    public VaricellaVaccine?: boolean;
    public HumanImmunodeficiencyVirus?: boolean;
    public HerpesSelf?: boolean;
    public HerpesPartner?: boolean;
    public SexuallyTransmittedInfection?: boolean;
    public AtRiskPopulation?: boolean;
    public Other?: boolean;

    constructor(fields?: Partial<MedicalHistoryInfectiousDisease>) {
        Object.assign(this, fields);
    }

    public setEmptyFieldsAsNo(): void {
        this.VaricellaDisease = this.VaricellaDisease || false;
        this.VaricellaVaccine = this.VaricellaVaccine || false;
        this.HumanImmunodeficiencyVirus = this.HumanImmunodeficiencyVirus || false;
        this.HerpesSelf = this.HerpesSelf || false;
        this.HerpesPartner = this.HerpesPartner || false;
        this.SexuallyTransmittedInfection = this.SexuallyTransmittedInfection || false;
        this.AtRiskPopulation = this.AtRiskPopulation || false;
        this.Other = this.Other || false;
    }
}

export { MedicalHistoryInfectiousDisease };
